import { createSlice } from "@reduxjs/toolkit";

export const releaseSlice = createSlice({
  name: "release",
  initialState: {},
  reducers: {},
});

export default releaseSlice.reducer;
